import React, { useEffect } from "react";
import { Link } from "basis";
import { GATEWAY_TITLE } from "../../core/constants";

import InfoCard from "./InfoCard";

export const GatewayCredentialsUpdated = ({ shop, appID, gatewayName }) => {
  const paymentAppURL = `https://${shop}/services/payments_partners/gateways/${appID}/settings`;

  useEffect(() => {
    setTimeout(() => {
      window.location.href = paymentAppURL;
    }, 3000);
  }, [paymentAppURL]);

  return (
    <InfoCard
      title="Redirecting to Shopify"
      description={`Thank you for choosing ${GATEWAY_TITLE[gatewayName]}, you will now be redirected to Shopify where you can now activate ${GATEWAY_TITLE[gatewayName]} as a payment option through your shopify store.`}
      addtDescription="If you do not get redirected to Shopify, Go back to Shopify using link below."
      gatewayName={gatewayName}>
      {shop && (
        <Link
          appearance="primary-button"
          variant="blue-button"
          href={paymentAppURL}
          newTab={false}>
          Back to Shopify
        </Link>
      )}
    </InfoCard>
  );
};

export default GatewayCredentialsUpdated;
